import { inject, Injectable, signal, WritableSignal } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { LoggerContext } from '../enums/logger-context.enum';
import { LoggerService } from './logger/logger.service';

@Injectable({
  providedIn: 'root',
})
export class RequestTrackerService {
  pendingRequests$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  loading: WritableSignal<boolean> = signal(false);

  private logger: LoggerService = inject(LoggerService);
  addPendingRequest(url: string) {
    this.pendingRequests$.next(this.pendingRequests$.value + 1);
    this.logger.log(LoggerContext.RequestTracking, 'addPendingRequest:', { count: this.pendingRequests$.value, url });
    this.loading.set(true);
  }

  removePendingRequest(url: string) {
    this.pendingRequests$.next(Math.max(this.pendingRequests$.value - 1, 0));

    if (this.pendingRequests$.value <= 0) {
      this.loading.set(false);
    }
    this.logger.log(LoggerContext.RequestTracking, 'removePendingRequest', { count: this.pendingRequests$.value, url });
    if (this.pendingRequests$.value < 0) {
      this.logger.error(LoggerContext.RequestTracking, 'Unexpected situation: pending requests count is negative', {
        count: this.pendingRequests$.value,
      });
    }
  }
}
